<template>
  <div class="index">
    <div class="indexmain" :style="setBackground">
      <!-- <div class="banner">
        <img src="@/assets/image/del/banner.jpg" alt />
      </div> -->
      <van-sticky @scroll="searchScroll">
        <div v-show="searchHeader" class="searchHeader" :class="opacity === 1 ? 'bg' : ''"
          :style="{ paddingTop: statusBar + 'rem' }" ref="statusBarPaddingtop">
          <div v-if="isLoad === '0'" :class="opacity === 1 ? 'btn' : 'btn1'" @click="jumpLogin()">
            登录
          </div>
          <div class="dengluDiv" v-if="isLoad === '1'">
            <img style="width:33px;" src="@/views/image/head portrait_logged in.png" alt @click="jumpSysSetting()" />
          </div>
          <div class="main" :style="{ background: `rgba(235,238,238, ${opacity})` }">
            <div class="main1" :class="opacity === 1 ? 'bg' : ''" @click="searchJump()">
              <img :src="searchIcon" alt="" srcset="" />
              <span>搜功能</span>
            </div>
          </div>
          <div class="icon">
            <!-- <img v-if="opacity === 1" src="@/views/image/kefu.png" @click="goto('/kefu')" alt /> -->
            <img v-if="opacity === 1" src="@/views/image/sh.png" @click="jumpQR()" alt />
            <img v-if="opacity === 1" src="@/views/image/xiaoxih.png" alt @click="jumpMessage()" />
            <!-- <img v-if="opacity === 0" src="@/views/image/kefu.png" @click="goto('/kefu')" alt /> -->
            <img v-if="opacity === 0" src="@/views/image/sb.png" @click="jumpQR()" alt />
            <img v-if="opacity === 0" src="@/views/image/xiaoxib.png" alt @click="jumpMessage()" />
            <div v-if="noticeCount > '0'" class="xxCount">
              {{ noticeCount }}
            </div>
          </div>
        </div>
      </van-sticky>

      <div class="banner">
        <van-swipe :show-indicators="true" :duration="1000">
          <van-swipe-item v-for="(item, i) in bannerImageArr" :key="i">
            <img @click="gotoSmall(item.appUrl, item.appId)" :src="require(`../../views/img/${item.imageUrl}`)" alt />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="topDiv">

        <div class="notice">
          <img src="@/views/img/notice.png" alt />
          <div>
            <transition name="van-fade" v-for="(item, i) in notice" :key="i">
              <p @click="goto('/notice')" class="van-ellipsis" v-show="noticeI === i">
                {{ item.noticeTitle }}
              </p>
            </transition>
          </div>
        </div>

        <div class="moreApp caringModel-wrap">
          <div class="moreIcon" v-for="(item, i) in menuList.myApp" :key="i"
            @click="gotoSmall(item.appUrl, item.appId)">
            <div class="icon bg1">
              <img class="appIconImg" v-if="item.appIcon" :src="item.appIcon" alt />
              <img v-if="item.isNew === '1'" class="newImg" src="@/views/image/icon_hot_application.png" alt />
              <img v-if="item.isHot === '1'" class="newImg" src="@/views/image/icon_new_application.png" alt />
            </div>
            <p class="fs16" v-html="item.appName"></p>
          </div>
          <div class="moreIcon" @click="getMore()">
            <div class="icon bg1">
              <img class="appIconImg" src="@/views/img/more.png" alt />
            </div>
            <p class="fs16">全部</p>

          </div>
        </div>

        <div class="hots">
          <van-swipe :show-indicators="true" :duration="1000">
            <van-swipe-item v-for="(item, i) in imageArr" :key="i" @click="gotoSmall(item.appUrl, item.appId)">
              <img :src="require(`../../views/img/${item.appIcon}`)" alt />
            </van-swipe-item>
          </van-swipe>
        </div>

        <div class="zqfw">
          <p>专区服务</p>
          <div style="overflow: hidden;position: relative;">

            <!-- <van-swipe :autoplay="0" indicator-color="#1E3CD2" :loop="false" :lazy-render="true" :show-indicators="false">
              <van-swipe-item v-for="(item, i) in menuList.topicApp" :key="i">
                <div class="zqfwyw" @click="zqfwywCkick('/topicDetail', item.topicId, item.topicName)" v-bind:style="{backgroundImage:'url('+zqfwbg[i].img+')'}">
                  <div class="zqywTop">
                    <p>{{ item.topicName }}</p>
                    <img src="@/views/img/hot.png" alt />
                  </div>
                  <div class="zqywBottom">
                    <p>{{ item.topicNote }}</p>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe> -->
            <!-- <div v-for="(item, i) in menuList.topicApp" :key="i">
              <div class="zqfwyw" @click="zqfwywCkick('/topicDetail', item.topicId, item.topicName)" v-bind:style="{backgroundImage:'url('+zqfwbg[i].img+')'}"> -->
            <div class="zqfwyw" @click="gotoSmall('masserver/authapp/dist/#/charge')"
              v-bind:style="{ backgroundImage: 'url(' + zqfwbg[0].img + ')' }">
              <!-- <div class="zqfwyw" @click="gotoSmall(item.appUrl)" v-bind:style="{backgroundImage:'url('+zqfwbg[i].img+')'}"> -->
              <!-- <div class="zqywTop">
                  <p>{{ item.topicName }}</p>
                  <img src="@/views/img/hot.png" alt />
                </div>
                <div class="zqywBottom">
                  <p>{{ item.topicNote }}</p>
                </div> -->
            </div>
            <div class="zqfwyw" @click="gotoSmall('pacserver/swapp/dist/#/pac/jump')"
              v-bind:style="{ backgroundImage: 'url(' + zqfwbg[1].img + ')' }">
            </div>
            <div class="zqfwyw" @click="gotoSmall('masserver/authapp/dist/#/pos/index')"
              v-bind:style="{ backgroundImage: 'url(' + zqfwbg[3].img + ')' }">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import "@/views/css/newIndex.scss";
import { Grid, GridItem, Swipe, SwipeItem, Field, Sticky } from "vant";
export default {
  name: "home",
  /**
   * 初始化数据
   */
  data() {
    return {
      notice: [],
      noticeI: 0,
      searchValue: "",
      statusBar: 0,
      opacity: 0,
      searchHeader: true,
      searchIcon: require("@/assets/image/search.png"),
      setBackground: {
        backgroundImage: "url(" + require("@/views/img/bgTop.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      },
      zqfwbg: [
        { img: require("@/views/img/kasfqdcx.png") },
        { img: require("@/views/img/emailbanner.png") },
        { img: require("@/views/img/kasfqdcx.png") },
        { img: require("@/views/img/yhycdzq.jpg") },
      ],
      imageArr: [
        {
          appIcon: "active_j.png",
          appUrl: "sfsappserver/swapp/dist/#/financing",
        },
        { appIcon: "active_b.png", appUrl: "masserver/swapp/dist/#/eci/index" },
      ],

      bannerImageArr: [
        // { imageUrl: "red.png", appUrl: null },
        { imageUrl: "banner4.jpg", appUrl: "masserver/authapp/dist/#/pos/index" },
        { imageUrl: "banner3.png", appUrl: "masserver/swapp/dist/#/subscribe" },
        { imageUrl: "banner2.png", appUrl: "masserver/authapp/dist/#/dec" },
        { imageUrl: "banner1.png", appUrl: null },

      ],
      menuList: [],
      isLoad: "0",
      noticeCount: "",
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
    };
  },
  computed: {
    getGoBackFlag() {
      return this.$store.state.goBackFlag;
    },
    getStatusBarFlag: {
      get() {
        return this.$store.state.statusBarFlag;
      },
      set(v) {
        this.getStatusBarFlag = v;
      },
    },
  },
  watch: {
    getGoBackFlag() {
      this.getMobileAppsAll();
    },
    statusBar() {
      this.$nextTick(function () {
        this.statusBar = this.$tool.statusBar(12);
      });
    },

    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue == window.scrollY) {
          //延时执行后当newValue等于window.scrollY，代表滚动结束
          console.log("滚动结束");
          if (newValue > 0) {
            this.$refs.statusBarPaddingtop.style.background = "#fff";
          }
          this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
        }
      }, 20); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
      if (this.oldScrollTop == oldValue) {
        //每次滚动开始时oldScrollTop与oldValue相等
        console.log("滚动开始");
        this.$refs.statusBarPaddingtop.style.background = "";
      }
    },
  },
  /**
   * 初始化
   */
  mounted() {
    // this.$nativeApi.previewFile("baidu", "123", "sadf").then((data) => {
    //   console.log(data);
    // });
    // this.$nativeApi.test().then((data) => {
    //   console.log("ni" + data);
    // });
    // this.$nativeApi.test().then((data) => {

    // });
    // // console.log(this.$nativeApi.test());

    // // const backData_s = window.location.search.substring(1);
    // this.testUtil().then((res) => {
    //   console.log(res);
    // });
    // this.testUtil2().then((res) => {
    //   console.log(res);
    // });
    this.statusBar = this.getVal(
      this.getVal(window.location.href.split("?")[1]).split("=")[1]
    );
    sessionStorage.setItem("statusBar", this.statusBar);
    this.statusBar = this.$tool.statusBar(12);
    console.log(this.statusBar, "ccc");
    this.$refs.statusBarPaddingtop.style.paddingTop = this.statusBar + "rem";
    localStorage.setItem("status", JSON.stringify(["undefined_false"]));
    window.backData = this.backData;
    // localStorage.setItem("statusBar", 44);
    // sessionStorage.setItem("statusBar", 44);
    window.getNotMessage = this.getNotMessage;
    window.getMobileAppsAll = this.getMobileAppsAll;
    window.gotoSmall = this.gotoSmall;

    this.getAppNoticetop();
    this.newNotice();
    let indexData = localStorage.getItem("indexData");
    if (
      indexData != undefined &&
      indexData != "undefined" &&
      indexData.length > 0
    ) {
      this.menuList = JSON.parse(localStorage.getItem("indexData"));
      this.BrFunction();
      console.log(this.menuList);
      this.getMobileAppsAll();
    } else {
      this.getMobileAppsAll();
    }

    this.handleScroll();
  },
  /**
   * 方法
   */
  methods: {
    getVal(data) {
      return typeof data == "undefined" ? "" : data;
    },
    handleScroll() {
      window.addEventListener("scroll", () => {
        this.scrollTop = window.scrollY;
      });
    },

    /**
     * 调用app方法的返回值
     */
    backData(val) {
      this.statusBar = val;
      sessionStorage.setItem("statusBar", val);
      sessionStorage.setItem("text", val);
      localStorage.setItem("text", val);
    },
    getNotMessage(val) {
      console.log("方法名");
      console.log("fourkeyResult");
      console.log("回调入参");
      console.log(val);
      if (val > "99") {
        val = "99+";
      }
      this.noticeCount = val;
    },

    /**
     * 获取置顶公告
     */
    getAppNoticetop() {
      // this.notice=[{"noticeId":"6","noticeTitle":"李克强:推广国际贸易\"单一窗口\" 实现通关一体化","noticeUrl":"xx","publishtime":"2019/02/15","endtime":"2022/02/15","publisher":"电子口岸数据中心","istop":"0","status":"1","creatTime":"2020-03-08 21:03:35","note":null,"noticeContent":null},{"noticeId":"8","noticeTitle":"图片测试","noticeUrl":"xx","publishtime":"2019/02/15","endtime":"2022/02/15","publisher":"电子口岸数据中心","istop":"0","status":"1","creatTime":"2020-03-08 21:03:35","note":null,"noticeContent":null},{"noticeId":"7","noticeTitle":"一致化贸易单证设计指南","noticeUrl":"xx","publishtime":"2019/02/15","endtime":"2022/02/15","publisher":"电子口岸数据中心","istop":"0","status":"1","creatTime":"2020-03-08 21:03:35","note":null,"noticeContent":null}];
      this.$http1
        .post("/zsdyckserver/app/notice/getNotices?isTop=1", {})
        .then((res) => {
          this.notice = res.resultData;
        })
        .catch((err) => {
          if (err === 302) {
            window.console.log(err);
          }
        });
    },
    /**
     * 公告滚动
     */
    newNotice() {
      setInterval(() => {
        if (this.noticeI + 1 < this.notice.length) {
          this.noticeI = this.noticeI + 1;
        } else {
          this.noticeI = 0;
        }
      }, 3000);
    },
    /**
     * 获取首页menu数据
     */
    getMobileAppsAll() {
      localStorage.setItem("indexData", JSON.stringify(this.menuList));
      this.$tool.callModule("getMessageCount", true);
      this.$http1
        .post("/zsdyckserver/app/Auth/getMobileApps", {})
        .then((res) => {
          localStorage.setItem("indexData", JSON.stringify(res.resultData));
          this.menuList = res.resultData;
          this.BrFunction();
          this.isLoad = "1";

        })
        .catch((err) => {
          if (err === 302) {
            console.log("ERROR302");
            this.getMobileApps();
            this.isLoad = "0";
            //         this.$tool.callModule("isLogin", false);
          }
        });
    },
    /**
     * searchJump搜索跳转原生
     */
    searchJump() {
      this.$tool.callModule("searchJump", true);
    },
    /**
     * 滚动监听
     */
    searchScroll(e) {
      if (e.scrollTop > 5) {
        this.opacity = 1;
      } else {
        this.opacity = 0;
      }
    },
    getMobileApps() {
      this.$http1.post("/zsdyckserver/app/getMobileApps").then((res) => {
        if (res.resultFlag === "1") {
          localStorage.setItem("indexData", JSON.stringify(res.resultData));
          this.menuList = res.resultData;
          this.BrFunction();
        }
      });
    },
    /**
     * 获取更多
     */
    getMore() {
      this.$router.push("/menuAll");
      // this.$tool.callModule("jumpMenuMore", "");
      // this.$tool.callModule("hidenTabBar", true);
    },
    /**
     * 跳转当前应用
     */
    goto(val, appid, type, info) {
      let flag = "0";
      for (let item of this.menuList.myApp) {
        if (item.appId == appid) {
          flag = "1";
          break;
        }
      }
      if (type === "/application") {
        this.$router.push({
          name: "application",
          params: {
            appid: `${appid}`,
            flag: `${flag}`,
            appPath: `${val}`,
            info: `${info}`,
          },
        });
        this.$tool.callModule("hidenTabBar", true);
      } else {
        this.$router.push(val);
      }
    },
    /**
     * 跳转小应用
     */
    /**
     * 跳转小应用
     */
    gotoSmall(val, id) {
      console.log(id);
      this.$http1.get("/zsdyckserver/app/access/" + id).then((res) => {
        console.log(res);
      });
      if (val) {
        let arr = val.split(":");
        if (arr[0] === "js") {
          this.$tool.callModule(arr[1]);
        } else {
          if (val === "" || val === null) {
            console.log("===");
            this.$toast("敬请期待哟！");
          } else {
            window.location.href = `${window.location.origin}/${val}`;
            // this.$tool.sessionData('#1e3cd2', 'true');
          }
        }
      }
    },
    /**
     * 还未完成功能
     */

    notDone() {
      // this.$toast("敬请期待哟！");
      window.location.href = "http://webchat.singlewindow.cn/";
    },

    jumpLogin() {
      this.$tool.callModule("jumpLogin", "");
    },

    jumpMessage() {
      this.$tool.callModule("jumpMessage", "");
    },
    jumpSysSetting() {
      this.$tool.callModule("jumpSysSetting", "");
    },
    jumpQR() {
      this.$tool.callModule("jumpQR", "");
    },

    zqfwywCkick(val, topicId, topicName) {
      this.$router.push({
        name: "topicDetail",
        query: {
          topicId: `${topicId}`,
          topicName: `${topicName}`,
        },
      });
    },
    BrFunction() {
      for (let i in this.menuList.myApp) {
        window.document.documentElement.setAttribute("data-theme", this.propt);
        if (
          window.document.documentElement.getAttribute("data-style") == "small"
        ) {
          this.menuList.myApp[i].appName = this.menuList.myApp[
            i
          ].appName.replace(/\|\|/g, "");
        } else {
          this.menuList.myApp[i].appName = this.menuList.myApp[
            i
          ].appName.replace(/\|\|/g, "<br/>");
        }
      }
    },
  },

  // beforeDestroy() {
  //   window.removeEventListener("scroll"); //离开当前组件别忘记移除事件监听哦
  // },

  components: {
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [Swipe.name]: Swipe,
    [Field.name]: Field,
    [Sticky.name]: Sticky,
    [SwipeItem.name]: SwipeItem,
  },
};
</script>

<style scoped lang="scss">
.index {
  background: #f3f7ff;
  // filter: grayscale(1) !important;

  .indexmain {
    overflow: hidden;

    .searchHeader {
      left: 0;
      top: 0;
      width: 100%;
      background: transparent;
      z-index: 10;
      padding: 10px 0;
      display: flex;

      &.bg {
        border-bottom: 1px solid #eff1f1;
        background: linear-gradient(to bottom,
            rgba(245, 245, 245, 1) 0,
            rgba(255, 255, 255, 0.5) 100%);
        /* 标准的语法 */
      }

      .dengluDiv {
        width: 48px;
        line-height: 30px;
        text-align: center;
        height: 33px;
      }

      .btn {
        width: 48px;
        line-height: 30px;
        text-align: center;
        font-size: 14px;
        color: #000;
      }

      .btn1 {
        width: 48px;
        line-height: 30px;
        text-align: center;
        font-size: 14px;
        color: #fff;
      }

      .icon {
        margin-left: 5px;
        width: 60px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          padding: 0 2px;
          width: 20px;
        }

        .xxCount {
          background-color: red;
          border-radius: 20% 20% 20% 20%;
          width: 20px;
          height: 15px;
          margin-bottom: 15px;
          font-size: 10px;
          line-height: 15px;
          color: #fff;
          margin-left: -10px;
          text-align: center;
        }
      }

      .main {
        width: 250px;
        height: 30px;
        //   margin: 0px 92px 0px 48px;
        text-align: center;
        background: #fff;
        border-radius: 32px;
        line-height: 30px;

        .main1 {
          border-radius: 32px;
          background: #fff;
          height: 30px;
          overflow: hidden;

          &.bg {
            background: transparent;
          }

          img {
            float: left;
            width: 16px;
            height: 16px;
            margin: 7px 7px 7px 13px;
          }

          span {
            float: left;
            color: #a0a5aa;
            font-size: 12px;
            display: block;
            margin: 9px 0 0 0;
            line-height: 16px;
          }
        }
      }
    }

    .banner {
      width: 345px;
      height: 127px;
      overflow: hidden;
      margin: 6px 15px;

      .bannerBottom {
        margin-top: -20px;
        position: absolute;
      }

      img {
        width: 100%;
        //     height: 100%;
      }
    }

    .topDiv {
      //  position: absolute;
      width: 375px;
      //     overflow: hidden;
    }

    .notice {
      //  padding: 19px 12px;
      //    width:327px;
      height: 50px;
      margin: 6px 15px;
      padding-left: 17px;
      display: flex;
      align-items: center;
      justify-content: left;
      flex-direction: row;
      background: #fff;

      img {
        height: 18px;
      }

      div {
        height: 18px;
        overflow: hidden;

        p {
          font-size: 14px;
          margin-left: 8px;
          color: #fdb904;
          flex: 1;
          text-align: left;
        }
      }
    }

    .moreApp {
      background: #fff;
      display: flex;
      width: 345px;
      //    height: 225px;
      margin: 0px 15px;
      flex-wrap: wrap;
      // padding-top: 20px;
      // padding-bottom: 4px;
      padding: 20px 0px;
      //     position: absolute;
      box-shadow: 2px 2px 5px 1px #ebedf0;

      .moreIcon {
        margin-top: 12px;
        width: 25%;
        //height: 75px;
        //      display: flex;
        text-align: center;

        //       margin-bottom: 10px;
        .icon {
          // margin-top: 20px;
          // margin-left: 29px;
          margin: auto;
          width: 39px;
          height: 39px;
          text-align: center;
          border-radius: 39px;

          .appIconImg {
            margin-top: 7.5px;
            width: 24px;
          }

          .newImg {
            position: absolute;
            width: 14px;
            padding-left: 5px;
          }

          &.bg1 {
            background: #f3f7ff;
          }

          &.bg1 {
            background: #f3f7ff;
          }

          &.bg1 {
            background: #f3f7ff;
          }

          &.bg1 {
            background: #f3f7ff;
          }

          &.bg1 {
            background: #f3f7ff;
          }
        }

        p {
          margin: 9px auto 0 auto;
          //width: 60px;
          text-align: center;
          font-size: 12px;
          color: #030f26;
        }
      }
    }

    .hots {
      margin: 6px 15px;
      height: 128px;
      overflow: hidden;

      img {
        border-radius: 5px;
        width: 345px;
        height: 128px;
      }
    }

    .zqfw {
      // height: 133.5px;
      margin: 12px 15px;
      margin-bottom: 48px;
      background-color: #fff;
      overflow: hidden;

      .van-swipe-item {
        width: 130px !important;
      }

      p {
        height: 24px;
        line-height: 24px;
        font-family: "PingFangSC-Regular";
        font-size: 18px;
        padding: 12px;
        font-weight: 600;
        color: #040f27;
      }

      .zqfwyw {
        height: 120px;
        width: 345px;
        border: 1px solid #eee;
        float: left;
        margin-bottom: 12px;
        border-radius: 5px;
        // box-shadow: 2px 2px 5px 1px #ebedf0;
        background-size: cover;

        .zqywTop {
          width: 128px;
          height: 28px;
          display: flex;

          p {
            font-family: "PingFangSC-Semibold";
            width: 86px;
            flex: 1;
            color: #fff;
            height: 15px;
            font-size: 15px;
            line-height: 15px;
            font-weight: bold;
            padding: 13px 0px 0px 8px;
          }

          img {
            width: 20px;
            height: 20px;
            float: right;
            padding: 0 4px;
          }
        }

        .zqywBottom {
          p {
            height: 12px;
            color: #fff;
            font-size: 12px;
            line-height: 12px;
            font-family: "PingFangSC-Regular";
            font-weight: 400;
            padding: 12px 8px;
          }
        }
      }
    }

    .commonly {
      padding: 20px 0px 20px 0px;
      background: #fff;

      .van-grid-item {
        &.border1 {
          border-right: 1px solid $lineColor;
          border-bottom: 1px solid $lineColor;
        }

        &.border2 {
          border-bottom: 1px solid $lineColor;
        }

        &.border3 {
          border-right: 1px solid $lineColor;
        }
      }

      .commonlyM {
        width: 100%;
        float: left;

        &.commonlyM2 {
          padding-top: 20px;
        }

        &.commonlyM1 {
          padding-bottom: 20px;
        }

        .top {
          width: 100%;
          display: flex;

          .left {
            display: flex;
            align-items: center;
            width: 33px;
            text-align: left;

            img {
              width: 20px;
            }
          }

          .right {
            flex: 1;
            height: 55px;

            .hot {
              overflow: hidden;

              p {
                color: $fontColor;
                font-size: 15px;
                float: left;
                font-weight: bold;
                line-height: 18px;
                width: 106px;
                height: 36px;
                display: flex;
                align-items: center;
                text-align: left;
              }

              span {
                float: right;

                img {
                  width: 16px;
                }
              }
            }

            .desc {
              padding-top: 4px;
              text-align: left;
              font-size: 12px;
              color: #adafbd;

              &.desc1 {
                padding-top: 0;
                padding-bottom: 0px;
              }
            }
          }
        }

        .bottom {
          padding-top: 5px;
          text-align: left;
          color: #d6daea;
          padding-bottom: 12px;
        }
      }
    }
  }
}
</style>